import request from '@webtrader/core/request';

import { ISymbol } from './symbols';

export enum EWatchlistFilter {
  POPULAR = 'POPULAR',
  TOP_LOSER = 'TOP_LOSER',
  TOP_GAINER = 'TOP_GAINER',
  FAVOURITES = 'MY_WATCHLIST',
  TOP_PICK = 'TOP_PICK',
  ALL = 'ALL'
}

export interface IGetWatchlistParams {
  code: EWatchlistFilter;
}

export interface ICrudWatchlistParams {
  symbol: string;
}

export default {
  category: (params: IGetWatchlistParams) => {
    return request.get<ISymbol[]>('/api/market/v1/symbols/category', {
      params
    });
  },
  items: (params: IGetWatchlistParams) => {
    return request.get<ISymbol[]>('/api/market/v1/watchlists', {
      params
    });
  },
  add: (params: ICrudWatchlistParams) => {
    return request.post<boolean>('/api/market/v1/watchlist', params);
  },
  delete: (params: ICrudWatchlistParams) => {
    return request.delete<boolean>('/api/market/v1/watchlist', {
      params
    });
  }
};
